import { cn } from "@/lib/utils";

const STATUS = {
  scheduled: "bg-blue-950/70 text-blue-300 border-blue-700/50",
  en_route: "bg-cyan-950/70 text-cyan-300 border-cyan-500/50",
  in_progress: "bg-amber-950/70 text-amber-300 border-amber-500/50",
  needs_review: "bg-rose-950/70 text-rose-300 border-rose-500/50",
  completed: "bg-emerald-950/70 text-emerald-300 border-emerald-500/50",
  none: "bg-slate-800/60 text-slate-400 border-slate-700",
  pending_review: "bg-rose-950/70 text-rose-300 border-rose-500/50",
  active: "bg-emerald-950/70 text-emerald-300 border-emerald-500/50",
  trialing: "bg-amber-950/70 text-amber-300 border-amber-500/50",
};

export function StatusPill({ status, className }) {
  const label = (status || "none").replace(/_/g, " ");
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-mono-tac uppercase tracking-wider",
        STATUS[status] || STATUS.none,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}

export function Eyebrow({ children, className }) {
  return <div className={cn("eyebrow text-amber-400", className)}>{children}</div>;
}

export function Spinner({ label = "Loading" }) {
  return (
    <div className="flex items-center gap-3 text-slate-400" data-testid="loading-spinner">
      <div className="h-5 w-5 animate-spin rounded-full border-2 border-slate-700 border-t-amber-400" />
      <span className="font-mono-tac text-xs uppercase tracking-widest">{label}</span>
    </div>
  );
}
